import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cargador',
  templateUrl: './cargador.component.html',
  styleUrls: ['./cargador.component.scss']
})
export class CargadorComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
